import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  changePwdSuccessMsg: "",
  changePasswordError: "",
};

const changePasswordSlice = createSlice({
  name: "changepwd",
  initialState,
  reducers: {
    userChangePasswordSuccess(state, action) {
      state.changePwdSuccessMsg = action.payload;
    },
    userChangePasswordError(state, action) {
      state.changePasswordError = action.payload.message;
    },
    resetChangePasswordState(state) {
      state.changePasswordError = "";
      state.changePwdSuccessMsg = "";
    },
  },
});

export const {
  userChangePasswordSuccess,
  userChangePasswordError,
  resetChangePasswordState,
} = changePasswordSlice.actions;

export default changePasswordSlice.reducer;
